import upperFirst from 'lodash/upperFirst';

export function formatError(error: string) {
  return `${upperFirst(error)}.`;
}
